import { render } from "./GroupUpdate.vue?vue&type=template&id=664c4861"
import script from "./GroupUpdate.vue?vue&type=script&lang=js"
export * from "./GroupUpdate.vue?vue&type=script&lang=js"

import "./GroupUpdate.vue?vue&type=style&index=0&id=664c4861&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__